import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const getters = {
    tax: state => {
        return state.tax;
    },

    taxList: state => {
        return state.taxList;
    },

    taxAutoAssignProductList: state => {
        return state.taxList.filter(t => t.auto_assign_product == 1);
    },
};

const state = {
    tax: {
        id: null,
        name: null,
        short_name: null,
        amount: null,
        mode: 0,
        inclusive: false,
        auto_assign_outlet: false,
        auto_assign_product: false,
        products: [],
    },
    taxList: [],
};

const mutations = {
    [type.SET_TAX_LIST](state, taxList) {
        state.taxList = taxList;
    },

    [type.SET_TAX](state, tax) {
        state.tax = tax;
    },

    [type.SET_TAX_ATTRIBUTE](state, { key, value }) {
        state.tax[key] = value;
    },
};

const actions = {
    getTax({ commit }, id) {
        let route = Laroute.route('franchise.inventory.tax.show', { id });

        return axios
            .get(route)
            .then(res => {
                commit(type.SET_TAX, res.data.data);
                return res.data.data;
            })
            .catch(err => {
                throw err;
            });
    },

    async getTaxList({ commit, dispatch }) {
        let api = Laroute.route('franchise.vue.gettaxselect');
        startLoading(dispatch, 'fetch-tax');

        try {
            const { data } = await axios.get(api);
            commit(type.SET_TAX_LIST, data.data);
            endLoading(dispatch, 'fetch-tax');
        } catch (e) {
            endLoading(dispatch, 'fetch-tax');
            throw e;
        }
    },

    createTax({ state }) {
        const route = Laroute.route('franchise.inventory.tax.store');
        const products = state.tax.products.map(p => p.id);
        const params = _.merge(state.tax, { products });

        return axios.post(route, params);
    },

    updateTax({ state }) {
        const route = Laroute.route('franchise.inventory.tax.update', {
            id: state.tax.id,
        });
        const products = state.tax.products.map(p => p.id);

        const params = _.merge(state.tax, { products });

        return axios.patch(route, params);
    },

    setTaxAttribute({ commit }, payload) {
        commit(type.SET_TAX_ATTRIBUTE, payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/tax.js